import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getAutoAllocation = createAsyncThunk(
    "tms/getAutoAllocation",
    async (tenderId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.post(`tms/tenders/${tenderId}/auto-allocate`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const getTenderBids = createAsyncThunk(
    "tms/getTenderBids",
    async (tenderId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/tenders/${tenderId}/bids`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const getTenderDetails = createAsyncThunk(
    "tms/getTenderDetails",
    async (tenderId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/tenders/${tenderId}`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const TenderSummarySlice = createSlice({
    name: "TenderSummarySlice",
    initialState: {
        tenderLoading: false,
        tenderData: null,
        tenderError: null,

        allocationLoading: false,
        allocationData: [],
        allocationError: null,

        bidsLoading: false,
        bidsData: [],
        bidsCount: 0,
        bidsError: null,
    },
    reducers: {
        resetTenderSummary: (state) => {
            state.tenderLoading = false;
            state.tenderData = null;
            state.tenderError = null;
            state.allocationLoading = false;
            state.allocationData = [];
            state.allocationError = null;
            state.bidsLoading = false;
            state.bidsData = [];
            state.bidsCount = 0;
            state.bidsError = null;
        },
    },
    extraReducers: (builder) => {
        // Tender Details
        builder.addCase(getTenderDetails.pending, (state) => {
            state.tenderLoading = true;
            state.tenderError = null;
        });
        builder.addCase(getTenderDetails.fulfilled, (state, action) => {
            state.tenderLoading = false;
            state.tenderData = action.payload?.data;
        });
        builder.addCase(getTenderDetails.rejected, (state, action) => {
            state.tenderLoading = false;
            state.tenderError = action.payload;
        });

        // Auto Allocation
        builder.addCase(getAutoAllocation.pending, (state) => {
            state.allocationLoading = true;
            state.allocationError = null;
        });
        builder.addCase(getAutoAllocation.fulfilled, (state, action) => {
            state.allocationLoading = false;
            state.allocationData = action.payload?.data || [];
        });
        builder.addCase(getAutoAllocation.rejected, (state, action) => {
            state.allocationLoading = false;
            state.allocationError = action.payload;
        });

        // Bids
        builder.addCase(getTenderBids.pending, (state) => {
            state.bidsLoading = true;
            state.bidsError = null;
        });
        builder.addCase(getTenderBids.fulfilled, (state, action) => {
            state.bidsLoading = false;
            state.bidsData = action.payload?.data || [];
            state.bidsCount = action.payload?.count || 0;
        });
        builder.addCase(getTenderBids.rejected, (state, action) => {
            state.bidsLoading = false;
            state.bidsError = action.payload;
        });
    },
});

export const { resetTenderSummary } = TenderSummarySlice.actions;
export default TenderSummarySlice.reducer;
